/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AggregatedAssignments,
  AssignmentDto,
  AssignmentEventType,
  AssignmentOrigin,
  AssignmentType,
  ChiliProduct,
  DistroAggregatedRecords,
  DistroEventType,
  MapString,
  NotNullFilter,
  PaginatedResultDistroNotRoutedRecord,
  PaginatedResultDistroRoutedRecord,
  RoutingDimensionAggLevel,
  RuleCategory,
  Summary,
} from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "distributed-records-reporting";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get detailed list of routed records/meetings
   *
   * @tags CRUD/DistroReport
   * @name GetRoutedRecordsMeetings
   * @request GET:/v1/tenant/{tenantId}/records
   * @secure
   */
  getRoutedRecordsMeetings = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /** @example ["DistroRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDistroRoutedRecord,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/records`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRoutedRecordsMeetings */
  getRoutedRecordsMeetingsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /** @example ["DistroRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/records`, query);

  /**
   * @description Get short info about not routed records (no match/error)
   *
   * @tags CRUD/DistroReport
   * @name GetNotRouted
   * @request GET:/v1/tenant/{tenantId}/not-routed
   * @secure
   */
  getNotRouted = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /** @example ["Errored"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDistroNotRoutedRecord,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/not-routed`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getNotRouted */
  getNotRoutedPathGetter = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /** @example ["Errored"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/not-routed`, query);

  /**
   * @description Get aggregated report of routed records in Distro
   *
   * @tags CRUD/DistroReport
   * @name GetAggregatedDistroRecords
   * @request GET:/v1/tenant/{tenantId}/aggregated-records
   * @secure
   */
  getAggregatedDistroRecords = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /** @example ["DistroRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DistroAggregatedRecords,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/aggregated-records`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAggregatedDistroRecords */
  getAggregatedDistroRecordsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /** @example ["DistroRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: DistroEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/aggregated-records`, query);

  /**
   * @description Get aggregated report of routed assignments
   *
   * @tags CRUD/GenericReport
   * @name GetAggregatedAssignments
   * @request GET:/v1/tenant/{tenantId}/aggregates
   * @secure
   */
  getAggregatedAssignments = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AggregatedAssignments,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/aggregates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAggregatedAssignments */
  getAggregatedAssignmentsPathGetter = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/aggregates`, query);

  /**
   * @description Get aggregated totals of routed assignments
   *
   * @tags CRUD/GenericReport
   * @name GetTotals
   * @request GET:/v1/tenant/{tenantId}/total
   * @secure
   */
  getTotals = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Summary,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/total`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTotals */
  getTotalsPathGetter = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
      /** @example "router" */
      aggRouteLevel: RoutingDimensionAggLevel;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/total`, query);

  /**
   * @description Get detailed list of assignments (records/meetings)
   *
   * @tags CRUD/GenericReport
   * @name GetRoutedAssignments
   * @request GET:/v1/tenant/{tenantId}/assignments
   * @secure
   */
  getRoutedAssignments = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType?: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AssignmentDto[],
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignments`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRoutedAssignments */
  getRoutedAssignmentsPathGetter = (
    tenantId: string,
    query: {
      /** @example "Meeting" */
      assignmentType?: AssignmentType;
      /** @example ["Concierge"] */
      product?: ChiliProduct[];
      /** @example ["RoundRobinLink","ConciergeRouting"] */
      assignmentOrigin?: AssignmentOrigin[];
      /**
       * @pattern [^\s\\/]+
       * @example "ws23224ovcnsdflbse;e"
       */
      workspace: string;
      /**
       * @pattern [^\s\\/]+
       * @example "fn34732n328730cngu403f30j"
       */
      router?: string;
      /**
       * @pattern [^\s\\/]+
       * @example "acdscbadlbj96w8csd"
       */
      route?: string;
      /** @pattern [^\s\\/]+ */
      rule?: string;
      /** @example "CatchAll" */
      ruleCategory?: RuleCategory;
      /**
       * @pattern [^\s\\/]+
       * @example "167a67d47a6da76d4a761"
       */
      team?: string;
      /** @example ["167a67d47a6da76d4a761"] */
      user?: string[];
      /**
       * @pattern [^\s\\/]+
       * @example "aceverve4422r"
       */
      distribution?: string;
      /** @example ["Distribution"] */
      notNull?: NotNullFilter[];
      /** @example ["Created"] */
      eventTypes?: AssignmentEventType[];
      /**
       * @format date-time
       * @example "2025-07-05T00:17:59.880986655Z"
       */
      since: string;
      /**
       * @format date-time
       * @example "2025-07-06T00:17:59.881543605Z"
       */
      until?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignments`, query);
}
